import { AxiosResponse } from 'axios';
import { axiosRequest } from '@/common/api/instance';
import { Meta, Response as ApiResponse } from '@/types/api/response.types';
import { Claim, CompleteClaim, UpdateClaim } from '@/types/api/sites.types';

const resource = '/draws';

export const initiateClaim = async (id: string): Promise<AxiosResponse<ApiResponse<Claim>>> => {
  return axiosRequest().post(`${resource}/${id}/claims`);
};

export const getClaimDetails = async (id: string): Promise<AxiosResponse<ApiResponse<Claim>>> => {
  return axiosRequest().get(`${resource}/${id}/claims`);
};

export const editClaim = async (
  id: string,
  data: UpdateClaim,
): Promise<AxiosResponse<ApiResponse<Claim>>> => {
  return axiosRequest().patch(`${resource}/${id}/claims`, data);
};

export const completeClaim = async (
  id: string,
  data: CompleteClaim,
): Promise<AxiosResponse<ApiResponse<Claim>>> => {
  return axiosRequest().patch(`${resource}/${id}/claims/status`, data);
};

export const deleteClaim = async (id: string): Promise<AxiosResponse<ApiResponse<Meta>>> => {
  return axiosRequest().delete(`${resource}/${id}/claims`);
};

export const downloadClaim = (id: string): Promise<AxiosResponse<Blob>> => {
  return axiosRequest().get(`${resource}/${id}/download`, { responseType: 'blob' });
};
